import React from "react";
import RegisterComponent from "../template/_common/registerComponent";

const SuperAdminRegister = () => {
  return <RegisterComponent roleType={"superadmin"} role={"1"} />;
};

export default SuperAdminRegister;
